
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import AddEmailMailingListRequest from '@app/models/add-email-mailing-list-request';
import { LogService, NotificationService, UserService, ValueService, Ga4Service } from '@app/services';
import { FormsModule } from '@angular/forms';

import { UsMapComponent } from '@app/new-search/us-map/us-map.component';

@Component({
    selector: "collect-email",
    templateUrl: "./collect-email.component.html",
    styleUrls: ["./collect-email.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, UsMapComponent]
})
export class CollectEmailComponent implements OnInit {
  private readonly _componentName = 'CollectEmailComponent';
  private _title: string = 'Stay up to date on new properties added near you!';
  private _responseText: string = 'You will now receive the latest listings in your area!';
  private _buttonText: string = 'Subscribe';
  private _submitting: boolean;
  private _zipCode: string;
  private _email: string;

  public offeringType: string = "None";
  /**
   * Fired when data is successfully submitted to the API
   */
  @Output()
  public submitted = new EventEmitter();

  /**
   * Fired when the modal is complete. Typically, when the user taps the modal after being shown the success panel.
   */
  @Output()
  public completed = new EventEmitter();

  public isSubmitted: boolean;
  private states: string[] = [];

    /**
   * Optionally pre-fill the email input field
   */
  @Input()
  public set initialEmail(value: string | undefined) {
    if (value) {
      this.email = value;
    }
  }
  
  constructor(
    private log: LogService,
    private notify: NotificationService,
    private valueService: ValueService,
    private userService: UserService,
    private ga4: Ga4Service
  ) {}

  ngOnInit() {}

  public get title(): string {
    return this._title;
  }

  @Input()
  public set title(v: string) {
    this._title = v;
  }

  public get buttonText(): string {
    return this._buttonText;
  }

  @Input()
  public set buttonText(v: string) {
    this._buttonText = v;
  }

  public get submitting(): boolean {
    return this._submitting;
  }

  public set submitting(v: boolean) {
    this._submitting = v;
  }

  public get zipCode(): string {
    return this._zipCode;
  }
  public set zipCode(v: string) {
    this._zipCode = v;
  }

  public get email(): string {
    return this._email;
  }
  public set email(v: string) {
    this._email = v;
  }

  public get responseText(): string {
    return this._responseText;
  }
  public set responseText(v: string) {
    this._responseText = v;
  }

  public get canSubmit(): boolean {
    if (this.zipCode && this.email) {
      if (!this.valueService.isValidEmail(this.email)) {
        return false;
      }

      if (this.zipCode.length !== 5) {
        return false;
      }

      return true;
    }

    return false;
  }

  /**
   * Handles the Continue button click
   */
  public onContinueClick(evt: MouseEvent) {
    if (this.log.verboseLogging) console.log(`${this._componentName}.onContinueClick evt=`, evt);

    this.submitting = true;
    // this.cd.detectChanges();

    let model = { emailAddress: this.email, zipCode: this.zipCode, states: [...this.states] } as AddEmailMailingListRequest;
    this.userService.addEmailToEmailList(model).subscribe(
      results => {
        this.submitting = false;
        this.isSubmitted = true;
        this.submitted.emit();

        // GA4: email lead captured (exit-intent / new-listings popup)
        this.ga4.generateLead('email_popup');

        localStorage.setItem('afterclapGiraffe', 'true');
      },
      err => {
        console.error(err);
        
        this.notify.error('An error occured submitting your email address.', null);
      }
    );
  }

  /**
   *  Handles the success panel click which emits a completed event (which parent component listens for and then closes the popup)
   */
  public onSuccessPanelClick(evt: MouseEvent) {
    if (this.log.verboseLogging) console.log(`${this._componentName}.onSuccessPanelClick evt=`, evt);

    this.completed.emit();
  }

  onStateMapClicked(data: any) {
    let stateId = data.stateId;
    let selected = data.selected;
    if (selected) {
      this.states.push(stateId);
    } else {
      let index = this.states.indexOf(stateId);
      if (index > -1) {
        this.states.splice(index, 1);
      }
    }
    console.log(`${this._componentName}.onStateMapClicked stateId=`, stateId, ` selected=`, selected);
  }
}





  

  
  
